import { render, staticRenderFns } from "./DashboardRequestTable.vue?vue&type=template&id=fc9e66c8&"
import script from "./DashboardRequestTable.vue?vue&type=script&lang=js&"
export * from "./DashboardRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRequestTable.vue?vue&type=style&index=0&id=fc9e66c8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports